import { updateSubscriptions } from '../../Data/SubscriptionCenterDataSource.js'
import {
  ACTIVE,
  INACTIVE,
  SERVICE_LABEL_USER,
  SERVICE_LABEL_ADVISOR,
  SERVICE_LABEL_INVESTOR,
} from '../../Landing/Helper/constants.js'

export async function updateFundSubscriptionBySubscriptionId(
  subscriptionProfile,
  id,
  selected
) {
  const subscription = {
    wholeSalerID: null,
    contactID: subscriptionProfile?.value?.contactID,
    publicationID: id,
    status: selected ? ACTIVE : INACTIVE,
    actor:
      subscriptionProfile?.value?.role === SERVICE_LABEL_ADVISOR
        ? SERVICE_LABEL_USER
        : SERVICE_LABEL_INVESTOR,
    updatedTimeStamp: new Date().toISOString(),
  }
  await updateSubscriptions({
    subscriptions: [subscription],
  })
}
